import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import shipment from '@/features/shipment/store';
import dashboard from '@/features/dashboard/store';
import auth from '@/features/auth/store';
import estimate from '@/features/estimate/store';
import history from '@/features/shipment-history/store';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { RootState } from '../types';
import { historyTableColumns } from '../raw';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    notification: false,
    notificationData: [],
    countries: [],
    loading: false,
    isCheckoutLoading: false,
    userPreferences: {
      id: 0,
      carrierFilters: [],
      printSettings: {
        labelSize: 'Standard',
      },
      schedulePickup: {
        closeTime: '',
        comments: '',
        location: '',
        readyTime: '',
      },
      shippingSettings: {
        autoCollapseAddress: true,
        comments: '',
        dimUnits: '',
        dimensionsMandatory: false,
        packageType: 'MyPackage',
        reference: '',
        showImportSection: false,
        showSummaryPage: false,
        signatureOption: 'None',
        weightUnits: 'Lbs',
        isAutomaticallyAddPackage: true,
        isReferenceMandatory: true,
        isHideShipperPhoneNumberFromLabel: true,
      },
      ecommerce: {
        fulfillOrder: false,
        storeNotification: false,
        insurance: false,
      },
      customsSettings: {
        reasonForExport: '',
        currencyCode: 'USD',
      },
      shipmentHistorySettings: {
        columnOrder: [...historyTableColumns],
      },
      websiteSettings: {
        autoCollapseSupportingDocuments: false,
      },
    },
    isUserPreferences: 0,
    theme: '',
    isNotificationsPrefs: false,
    notificationPrefs: [],
    confirmDialog: {
      show: false,
    },
    userInfo: {
      account: '',
      firstname: '',
      fullName: '',
      lastname: '',
      userId: 0,
      username: '',
      isShowCheckIn: false,
      isSurveyRequired: false,
      isDefaultAddressRequired: false,
      isUseNewSite: true,
    },
    alertDialogs: [],
    isInitialDataLoaded: 0,
  },

  mutations,
  actions,
  getters,

  modules: {
    shipment,
    dashboard,
    auth,
    estimate,
    history,
  },
};

export default new Vuex.Store<RootState>(store);
